module.exports = __webpack_public_path__ + "static/img/logo_h2.8827015d.png";